import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=7d28a75a&scoped=true&"
import script from "./SlideProduct.vue?vue&type=script&lang=js&"
export * from "./SlideProduct.vue?vue&type=script&lang=js&"
import style0 from "./SlideProduct.vue?vue&type=style&index=0&id=7d28a75a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d28a75a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VRow,VSheet})
